export enum EventColour {
  General,
  Warning,
  Exception,
}
